import { TypePolicies } from '@apollo/client';

export const travelCachePolicies: TypePolicies = {
  TravelOffer: {
    keyFields: ['offerToken'],
  },
  TravelOfferReservation: {
    keyFields: ['id'],
  },
  TravelPricingByPropertyIdItem: {
    keyFields: ['property', ['joyPlaceId']], // Use `property.joyPlaceId` as part of the cache key
  },
  ExtendedAccommodationCatalogProperty: {
    keyFields: false, // Disable normalization - pricing and scores are date-dependent
  },
  Query: {
    fields: {
      travelOfferFromOfferToken: {
        read(existing, { args, toReference }) {
          // if the response was cached as defined or null (404), return existing
          if (existing !== undefined) return existing;
          if (!args?.payload) return undefined;

          return toReference({
            __typename: 'TravelOffer',
            // If Apollo Client cache misses, tell server to use its cache rather than fetching live data from ZentrumHub
            offerToken: args.payload,
          });
        },
      },
      travelOfferReservationById: {
        read(existing, { args, toReference }) {
          if (existing !== undefined) return existing;
          if (!args?.id) return undefined;

          return toReference({
            __typename: 'TravelOfferReservation',
            id: args.id,
          });
        },
      },
      travelReservationBookingDetails: {
        keyArgs: ['eventId'],
      },
    },
  },
};
